import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GearAppService, GearProxyService, GearTypes } from 'common-gear';
import { AddOnTypes, AppService, ColorPickerService, CommonCloudstudioService, CommonMapService, CoreProxyService, CoreTypes, FormParametersComponent, FormValidatorService, IMultiSelectOption, IncidentsService, LabelValue, Modal, ReplaceLiteralsPipe, SharedCommonService, StringDateTimePipe, TableTypes, Year } from 'common-cloudstudio';
import { Observable, Subscription, forkJoin } from 'rxjs';
import { MapService } from '../../shared/services/map.service';
import { MapsAPILoader } from '@agm/core';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { IncidentTypes } from 'common-cloudstudio';
import { IncidentService } from '../services/incident.service';
import { IncidentFormComponent } from '../incident-form/incident-form.component';

export interface IncidentITSMap extends CoreTypes.IncidentITSMap, CoreTypes.IncidentITSMap_Incident,
CoreTypes.IncidentITSMap_Facility, CoreTypes.IncidentITSMap_Device, CoreTypes.IncidentITSMap_ITSReferencePoints { }

interface Metadata {
  id: any;
}

export interface IconMarker {
  latitude: number;
  longitude: number;
  url: string | google.maps.ReadonlyIcon | google.maps.ReadonlySymbol;
  html?: string;
  metadata: Metadata;
}

@Component({
  selector: 'app-incident-map',
  templateUrl: './incident-map.component.html',
  styleUrls: ['./incident-map.component.scss'],
})
export class IncidentMapComponent implements OnInit, OnDestroy {
  today = new Date();

  @ViewChild('formElement') public _formElement: NgForm;
  @ViewChild('formElementModal') public _formElementModal: NgForm;
  @ViewChild('detailModal') detailModal: Modal;
  @ViewChild('firstElement') public firstResizeElement: ElementRef;
  @ViewChild('formParam') formParam: FormParametersComponent;
  @ViewChild('incidentForm') private _incidentForm: IncidentFormComponent;

  bounds: any;
  _confirmSaveChanges: boolean;
  _confirmChangeTab: number = 0;
  _goToChatGroup: number = 0;
  _lastOpenInfoWindow: any;
  _longitudeCenter: number = -71.86585;
  _latitudeCenter: number = -36.07055;
  _zoom: number = 1.9;
  _mapWidth: string;
  map: google.maps.Map;
  errorMess = "";
  incidentParams: CoreTypes.FormParameter[] = [];
  clustersFullList: {
    incidentData: IncidentITSMap;
    markerData: IconMarker;
  }[] = [];
  clustersFilteredList: {
    incidentData: IncidentITSMap;
    markerData: IconMarker;
  }[] = [];
  _activeMarker: number;

  _dataPacketSub: Subscription;
  _pathsUtilityCompanies: any;
  _pathsMaintenanceContractors: any;
  _deviceModalId: number;
  subscriptions: Subscription[] = [];

  _deviceModalTextAttributes: CoreTypes.TextAttributeList[];
  _successMessage: string;
  _errorMessage: string;
  _communicationID : number;
  _incidentID : number = 0;
  _monthlyID : number = 0;
  _dateCreated : string = "";

  executionNumber: number = 0;
  clientID: number;
  facilityID: number;
  firstExecution: boolean = true;
  firstTime: boolean = true;
  activeModalTab = 0;
  facilityData: GearTypes.GearMapFacility = new GearTypes.GearMapFacility();
  _facilityID: number;
  status: number = 0;
  facilitiesIds: number[] = [];

  _errorBackEnd = "";

  private _destroyed = false;
  private _sequenceNumber = 0;
  private timer: any;
  private searchTimeOut: any;
  private indexTable: Array<number> = [];
  addOnIncidents: GearTypes.BasicMasterEntityAddOnFeatures = new GearTypes.BasicMasterEntityAddOnFeatures();
  addOnFeatureVisibility = AddOnTypes.AddOnVisibilityTypes;
  addOnFeatureIDs = AddOnTypes.AddOnFeatureIDs;
  addOnIncident:GearTypes.BasicMasterEntityAddOnFeatures = new GearTypes.BasicMasterEntityAddOnFeatures();

  activeContent: number = 0;
  activeContentClone: number = 0;

  activeTitle: string = '';
  sidebarItems = [{
    IconName: 'fa-solid fa-plus',
    MenuID: 23,
    Title: 'Nuevo Evento',
  },
  // {
  //   IconName: 'fa fa-filter',
  //   MenuID: 24,
  //   Title: this._appService?.CoreCommonLiterals?.Filter,
  // },
  {
    IconName: 'fa-brands fa-whatsapp',
    MenuID: 25,
    Title: 'Chat',
  }]
  displayContent: boolean;
  maxWidthSidebar:number;
  sidebarWidth:number;

  mapPointType = IncidentTypes.PointType;
  mapType = IncidentTypes.MapType;

  newMarker: google.maps.Marker;
  infowindow: google.maps.InfoWindow;
  geocoder: google.maps.Geocoder;
  eventListener: any;
  listenerStop: any;
  mapReady: boolean = false;
  incidentPermissions: boolean = true;
  debounceAction: any;

  latutude: number;
  longitude: number;

  formParameterList: CoreTypes.FormParameter[];
  formParameterApplied: CoreTypes.FormParameter[] = [];
  paramSelected: CoreTypes.FormParameter = new CoreTypes.FormParameter();
  cloneParams: Array<CoreTypes.FormParameter> = [];
  subscription: Subscription;
  enableFilter: boolean = true;
  loaderFilter: number = 0;

  incidentID: number = 0;
  placeData: {
    Marker: string,
    Location: any,
    ChangeFilter: boolean;
  };
  generalLiteral: string = ''
  langPlatform: string = 'ES_AR';

  constructor(
    public _mapService: MapService,
    public commonMapService: CommonMapService,
    private _gearProxyService: GearProxyService,
    public _appService: AppService,
    public _gearService: GearAppService,
    public mapsAPILoader: MapsAPILoader,
    private _coreProxyService: CoreProxyService,
    private _activatedRoute: ActivatedRoute,
    public _formValidatorService: FormValidatorService,
    private colorService: ColorPickerService,
    public sanitizer: DomSanitizer,
    private incidentService: IncidentService,
    private replaceLiterals: ReplaceLiteralsPipe,
    private incidentsService: IncidentsService,
    private sharedCommonService: SharedCommonService,
    public commonService: CommonCloudstudioService
  ) {
    this._appService.notLoadTawkTo.next(true);
  }

  ngOnInit() {
    this._facilityID = this._appService.getFacilityID();
    this.subscriptions.push(this._gearService.onChangeFacilityID.subscribe(facilityID => {
      if (this._facilityID === facilityID) { return; }
      this.status = 0;
      this._facilityID = this._appService.getFacilityID();
      this.formParameterApplied = null;
      this.getFilterData();
      // this.cleanForm();
    }))

    this._activatedRoute.params.subscribe(params => {
      this._communicationID = params.comunicationID;
      if(this._appService.sidebarIsOpen()) {
        this._appService.sidebarToggler();
      }
    });
    this.subscriptions.push(this._gearService.onGearPermissionList.subscribe(permissions => {
      if(permissions){;
        this.incidentPermissions = this._appService.contains(permissions.Monitor.ClientIncidents, CoreTypes.PermissionOperation.Edit);
      }
    }));
    this.subscriptions.push(this._gearService.addOnFeaturesPermissions.subscribe(addOns => {
      if(!addOns || !addOns.length) { return; }
      this.addOnFeature(addOns);
    }));

    if (this._appService.CoreCommonLiterals && this._gearService.GearMonitorLiterals) {
      this.loadData();
    }
    this.subscriptions.push(this._gearService.onLiteralsSet.subscribe(() => {
      this.loadData();
    }));

    this.subscriptions.push(this.sharedCommonService.onRefreshFormParameter.subscribe(() => {
      this.enableFilter = false;
      this.onInputFilter();
    }));

    this.subscriptions.push(this._appService.onToggleButtonState.subscribe(state => {
      this.ChangeRefreshParameters(state);
    }))
    this.subscriptions.push(this._appService.onCollapsibleSidebarToggles.subscribe(async toggle => {
      if(toggle) { this.activeContentClone = null; }
    }));
  }

  ngOnDestroy() {
    clearTimeout(this.timer);
    this._destroyed = true;
    this.incidentService.cleanVariablesFacility();
    this.incidentService.cleanVariablesClient();
    this._dataPacketSub?.unsubscribe();
    if(this.subscription) { this.subscription.unsubscribe(); }
    this.subscriptions.forEach(s => s.unsubscribe());
    document.removeEventListener('contextmenu', this.listenerStop, false);
    if(!this._appService.collapsibleSidebarIsOpen()) {
      this._appService.collapsibleSidebarToggler();
    }
    this._appService.notLoadTawkTo.next(false);
  }

  loadData() {
    forkJoin([
      this.getVehiclesIcons(),
    ])
    .subscribe({
      complete: () => { }
    });
  }

  getVehiclesIcons() {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(this._appService.onMapIconDetails.subscribe(icons => {
        if(!icons) return;
        resolve(icons);
      },
      error => {
        reject(error);
      }))
    });
  }

  initData() {
    clearTimeout(this.timer);
    this.status = 0;
    this.indexTable = [];
    this.clustersFullList = [];
    this.clustersFilteredList = [];
    this._sequenceNumber = 0;
    this.firstExecution = true;
    this.firstTime = true;
    this.getRecursively();
  }

  getRecursively() {
    this.addOnIncident = this._gearService.addOnFeaturesPermissionsList?.find(add => add.AddOnFeatureID == this.addOnFeatureIDs.IncidentManagement);
    if(this._destroyed || !this._appService.getAccessToken()) { return;}
    if(this._dataPacketSub) { this._dataPacketSub.unsubscribe(); }
    this._dataPacketSub = this.getDataPackages().subscribe(data => {
      this.status = 1;
      this.loaderFilter = 0;
      this.getRecursively();
    }, (interval) => {
      this.timer = setTimeout(()=> this.getRecursively(), interval);
      this.loaderFilter = 2;
    })
  }

  getDataPackages(): Observable<number> {
    this.executionNumber++;
    let executionNumber: number = this.executionNumber;
    return new Observable(observer => {
      if(!this._appService.onMapIconDetails.value) {
        setTimeout(() => {
          observer.next();
        }, 100);
        return;
      }
      this._coreProxyService.IncidentService.GetIncidentITSMapDataPacket(
        this._appService.getAccessToken(),
        this._appService.getClientID(),
        this._appService.getFacilityID(),
        this.facilitiesIds,
        this._sequenceNumber,
        500,
        this.formParameterApplied,
        success => {
          this.status = 1;
          // Controlar que el request que se está ejecutando en este success sea el ultimo ejecutado por el programa
          if(executionNumber !== this.executionNumber) {
            this.firstExecution = false;
            observer.next();
            return;
          }
          try {
            if (this._sequenceNumber > success.HightestSequenceNumber) {
              return observer.next();
            }

            this._sequenceNumber = success.HightestSequenceNumber;
            if (this.firstExecution) {
              const southWest = { lat: -36.6066, lng: -72.1028 }; // Chillán
              const northEast = { lat: -35.5345, lng: -71.6289 }; // (Talca)
              this.bounds = new google.maps.LatLngBounds(southWest, northEast);
              // var sw = new google.maps.LatLng(success.InitialViewSW.Latitude, success.InitialViewSW.Longitude);
              // var ne = new google.maps.LatLng(success.InitialViewNE.Latitude, success.InitialViewNE.Longitude);
              // this.bounds = new google.maps.LatLngBounds(sw, ne);
              this.map.fitBounds(this.bounds);
            }

            const sites = success.Points as IncidentITSMap[];
            let refreshed = [];
            for (let index = 0; index < sites.length; index++) {
              if(sites[index].PointType === this.mapPointType.Incident) {
                refreshed.push(sites[index].IncidentID);
                this.addMarker(sites[index], "Incident");
              } else if( sites[index].PointType === this.mapPointType.Facility){
                refreshed.push(sites[index].FacilityID);
                this.addMarker(sites[index], 'Facility');
              }
            }

            this.firstExecution = false;
            observer.next();
          } catch (error) {
            observer.error(5000);
          }
        },
        err => {
          this.status = 2;
          this._appService.showException(err);
          observer.error(15000);
        }
      );
    });
  }

  addMarker(item: IncidentITSMap, type: string) {
    if (!item.LocationAddress?.Location) return;
    let color = this.colorService.rgbToHexa((item.PointColor));
    let index = type == 'Incident'? this.indexTable.indexOf(item.IncidentID): this.indexTable.indexOf(item.FacilityID);
    let svgMarker = {
      url: 'data:image/svg+xml;utf-8,' + encodeURIComponent(this.incidentService.getIcon(color, item.IconID)),
      size: new google.maps.Size(40, 40),
      scaledSize: new google.maps.Size(25, 40),
    };
    var markert: google.maps.Marker = new google.maps.Marker({
      icon: type == 'Incident' ? svgMarker : this.pin(color, false),
    });

    if (index > -1) {
      // Si ya existe, actualizar sus valores
      this.clustersFullList[index].incidentData = item;
      this.clustersFullList[index].markerData.url = markert.getIcon();
      this.clustersFullList[index].markerData.latitude = item.LocationAddress.Location.Latitude;
      this.clustersFullList[index].markerData.longitude = item.LocationAddress.Location.Longitude;
      this.clustersFullList[index].markerData.html = this.getMarkerHTML(type, item);

      // Si se realizó una busqueda, tambien actualizar los valores en ese listado filtrado.
      if(this.clustersFilteredList[index]) {
        this.clustersFilteredList[index].incidentData = item;
        this.clustersFilteredList[index].markerData.url = markert.getIcon();
        this.clustersFilteredList[index].markerData.latitude = item.LocationAddress.Location.Latitude;
        this.clustersFilteredList[index].markerData.longitude = item.LocationAddress.Location.Longitude;
        this.clustersFilteredList[index].markerData.html = this.getMarkerHTML(type, item);
      }
    } else {
      // Si no existe, agregarlo
      const cluster = {
        incidentData: item,
        markerData: {
          latitude: item.LocationAddress.Location.Latitude,
          longitude: item.LocationAddress.Location.Longitude,
          url: markert.getIcon(),
          metadata: { id: type == 'Incident' ? item.IncidentID : item.FacilityID},
          html: this.getMarkerHTML(type, item)
        }
      };

      this.indexTable.push(item.IncidentID);
      this.clustersFullList.push(cluster);
      this.clustersFilteredList.push(cluster);
      this.facilityData = {
        Description: item.Description,
        FacilityID: item.ClientID,
        ShowGroupedAlarmsOnMaps: item.ShowGrouped,
        IconID: null,
        Location: null,
        Stats: null
      }
    }
  }

  getMarkerHTML(type, item:IncidentITSMap) {
    let htmlMarker = `
    <div>
      <p style="font-size:18px; font-weight: bold; text-align:center">
        <strong>${ type == 'Incident' ? 'Evento' + ' #' +item.MonthlyID : 'Facility' }</strong><br>
      <small><small>
        ${ type == 'Incident' ?  'Identificador Global #' +item.IncidentID : '' }
      </small></small>
      </p>
      <p>
        <strong>${item?.Description}</strong>
      </p>
      <p>
        <strong>${ item.IncidentID ? (item.Opened ? 'Estado: Abierto' : 'Estado: Cerrado') : ''}</strong>
      </p>
    </div>`
    return htmlMarker;
  }

  onMapReady($event) {
    this.map = $event;
    this.mapReady = true;

    if(this._appService.getClientID()) {
      this.clientID = this._appService.getClientID();
      this.getFilterData();
    }

    this.subscriptions.push(this._appService.onFacilitySet.subscribe(_ => {
      const clientID = this._appService.getClientID();
      if (this.clientID === clientID) { return; }
      this.clientID = clientID;
      this.initData();
    }));

    //Incluir traficLayer
    // let trafficLayer = new google.maps.TrafficLayer();
    // trafficLayer.setMap($event);
  }

  onRightClick(marker: IconMarker) {
    if(this.activeContent == 23 && !this._appService.collapsibleSidebarIsOpen()) return;
    let element =  event.target as Element
    let boundingClientRect = element.getBoundingClientRect();
    this._incidentID = marker.metadata.id;
    this.displayContexMenu(null, boundingClientRect);
    this.listenerStop = (event) => { event.preventDefault(); };
    document.addEventListener('contextmenu', this.listenerStop, false);
  }

  onMarkerClick(marker: IconMarker) { }

  onFacilityModalClose() {
    this._deviceModalTextAttributes = [];
    this._deviceModalId = 0;
  }

  onCenterChange($event) {}

  boundsChange($event) {}

  onZoomChange($event) {  }


  applyFilters(controlName:string) {
    this.today = new Date();
  }

  onConfirmChangeTab(save) {
    this.activeContent = this._confirmChangeTab;
    this.activeContentClone = this._confirmChangeTab;
    this.activeTitle = this.sidebarItems.find(x => x.MenuID === this.activeContent)?.Title;
    this._confirmChangeTab = 0;
    if(this._goToChatGroup)  {
      this.incidentsService._goToChatGroup.next(this._goToChatGroup);
      this._goToChatGroup = 0;
    }
  }

  getLatLng(lat, lng) {
    return new google.maps.LatLng(lat, lng);
  };

  mapClicked(event) {
    this.cleanContextMenu();
    google.maps.event.addListener(this.map, 'dblclick', (e) => {
      clearTimeout(this.debounceAction);
    });

    this.eventListener = google.maps.event.addListener(this.map, 'click', (e) => {
      clearTimeout(this.debounceAction);
      this.debounceAction = setTimeout(() => {
        if(this._incidentID && !this._appService.collapsibleSidebarIsOpen()) { return;}
        var lat = e.latLng.lat();
        var lng = e.latLng.lng();
        this.infowindow = new google.maps.InfoWindow();
        this.geocoder = new google.maps.Geocoder();
  
        this.setNewMarker(this.getLatLng(lat, lng), false, true);
        this.placeData = null;
        this.getPlacePosition(this.newMarker, e.latLng, true);
      }, 300)
    });
  }

  createFromLocation(marker, location, changeFilter) {
    this.placeData = { Marker: marker, Location: location, ChangeFilter: changeFilter };
  }

  bindMarkerinfo(marker) {
    google.maps.event.addListener(marker, "click", (point) => {
      this.cleanContextMenu();
      // this.infowindow.setContent(marker.html);
      // this.infowindow.open(this.map, marker);
    });
  };

  bindMarkerEvents(marker) {
    google.maps.event.addListener(marker, "rightclick", (point) => {
      this.displayContexMenu(point);
    });
  };

  displayContexMenu(event, domRect?) {
    if(this.activeContent == 23 && !this._appService.collapsibleSidebarIsOpen()) return;
    let menuBox = document.getElementById("menuAddIncident");
    var left, top;
    if(event) {
      for (let prop in event) {
        if (event[prop] instanceof MouseEvent) {
          let mouseEvt = event[prop];
          left = mouseEvt.clientX;
          top = mouseEvt.clientY;
          menuBox.style.left = left + "px";
          menuBox.style.top = top + window.scrollY + "px";
          menuBox.style.display = "block";
          mouseEvt.preventDefault();
        }
      }
      this._incidentID = null;
      this._monthlyID = null;
    } else if(domRect) {
      left = domRect.x;
      top = domRect.y;

      menuBox.style.left = left + "px";
      menuBox.style.top = top + window.scrollY + "px";
      menuBox.style.display = "block";
      this.newMarker?.setMap(null);
    }
    this.map.setOptions({ scrollwheel: false, draggable:false })
  }

  centerMap(location) {
    this.map.setCenter(location);
    this.infowindow = new google.maps.InfoWindow();
    this.geocoder = new google.maps.Geocoder();
  } 

  cleanMarker(event) {
    if(event && this.newMarker) {
      this.infowindow?.close();
      this.infowindow = null;
      this.newMarker.setMap(null);
      this.newMarker = null;
    }
  }

  addNewMarker(data) {
    this.setNewMarker(data?.Location, data?.Animation, true);
  }

  updateMapEvents() {
    this.onDragendNewMarker(this.newMarker);
    this.onMouseoverNewMarker(this.newMarker);
    this.onMouseOutNewMarker(this.newMarker);
    this.bindMarkerEvents(this.newMarker);
  }

  setNewMarker(location:google.maps.LatLng , animation: boolean, callMapEvents?: boolean) {
    const color = 'gray';
    
    if(this.newMarker) {
      this.cleanMarker(true);
    }
    this.infowindow = new google.maps.InfoWindow();

    this.newMarker = new google.maps.Marker({
      position: location,
      map: this.map,
      icon: this.pin(color),
      draggable: true
    });
    if(animation){
      this.newMarker.setAnimation(google.maps.Animation.DROP);
    }

    this._incidentID = null;
    this.incidentID = null;
    this._monthlyID = null;
    if(callMapEvents) {
      this.updateMapEvents();
    }
  }

  pin(color, circle?:boolean) {
    let path;
     circle ? path = "M-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0" : path = 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0';
    return {
      path :path,
      fillColor: color,
      fillOpacity: 1,
      strokeColor: '#000',
      strokeWeight: circle ? .1 : .5,
      scale: 1,
    };
  }

  onClickclearText() {
    this.newMarker?.setMap(null);
    this.infowindow?.close();
    this._errorBackEnd = "";
    this.cleanContextMenu();
  }

  onMouseoverNewMarker(marker) {
    google.maps.event.addListener(marker, 'mouseover', (event) => {
      this.getPlacePosition(marker, event.latLng);
    });
  }

  onMouseOutNewMarker(marker) {
    google.maps.event.addListener(marker, 'mouseout', () => {
      this.infowindow.close();
    });
  }

  onDragendNewMarker(marker) {
    google.maps.event.addListener(marker, 'dragend', (event) => {
      this.cleanContextMenu();
      this.getPlacePosition(marker, event.latLng, true);
    });
  }

  getPlacePosition(marker, latLng, changeFilter?:boolean) {
    this.geocoder.geocode({ location: latLng }, async (results, status) => {
      if (status == google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          marker.setPosition(latLng);
          if(changeFilter) {
            if(!this._appService.collapsibleSidebarIsOpen()) {
              this._incidentForm.setPlacePosition(results, latLng.lat(), latLng.lng());
            } else {
              this.createFromLocation(marker, latLng, true);
            }
          }
          this.infowindow.setContent('<div class="d-flex">' + results[0].formatted_address + '</div>' );
          this.infowindow.open(this.map, marker);
        }
      }
    });
    setTimeout(() => { if(this.eventListener) this.eventListener.remove();}, 10);
  }

  openSidebar(event) {
    this.activeContent = event;
    if(event === 23 && this.activeContentClone != 23) {
      this._incidentID = 0;
      
      setTimeout(() => {
        this._incidentForm?.cleanForm();
        this._incidentForm?.setInitData();
      }, 300);
    } else if(event !== 23 && !this._appService.collapsibleSidebarIsOpen() && (this._incidentForm?.searchControl || this.incidentID)){
      this._incidentForm?.exitEditing(event);
    } else {
      this.incidentsService._goToChatGroup.next(null);
    }
    this.activeContentClone = event;
    this.activeTitle = this._incidentID && this.activeContent === 23 ? 'Editar Evento' : this.sidebarItems.find(x => x.MenuID === this.activeContent)?.Title;
  }

  exitEditing(event, groupPos?:number) {
    this.activeContent = 23;
    this._confirmChangeTab = event;
    this.activeTitle = this._incidentID && this.activeContent === 23 ? 'Editar Evento' : this.sidebarItems.find(x => x.MenuID === this.activeContent)?.Title;
    this.incidentID = null;
  }

  createIncident() {
    if(this._appService.collapsibleSidebarIsOpen()) {
      this._appService.collapsibleSidebarToggler();
      this.activeContent = 23;
      if(this.placeData && this.placeData.Marker) {
        setTimeout(() => { 
          this.getPlacePosition(this.placeData.Marker, this.placeData.Location, this.placeData.ChangeFilter);
        }, 100);
      }
    }
    this.incidentID = 0;
    // this.setSidebarIcon();
    this.activeTitle = this.sidebarItems.find(x => x.MenuID === this.activeContent)?.Title;
    this.cleanContextMenu();
  }

  setSidebarIcon() {
    let pos = this.sidebarItems.findIndex(i => i.MenuID == 23);
    if(this._incidentID && !this._appService.collapsibleSidebarIsOpen()) {
      if(pos > -1) {
        this.sidebarItems[pos].IconName = 'fa-solid fa-pen';
      }
    } else {
      this.sidebarItems[pos].IconName = 'fa-solid fa-plus';
    }
  }

  async editIncident() {
    if(this._appService.collapsibleSidebarIsOpen()) this._appService.collapsibleSidebarToggler();
    this.activeContent = 23;
    this.cleanContextMenu();
    this.incidentID = this._incidentID;
    this.activeTitle = "Editar Evento";
  }

  cleanContextMenu() {
    this._appService.closeIncidentMenu();
    this._errorBackEnd = "";
    this.map.setOptions({ scrollwheel: true, draggable:true })
  }

  sidebarClose(event) {
    if(event && this.firstResizeElement.nativeElement) {
      this.firstResizeElement.nativeElement.removeAttribute("style");
      this._incidentID = null;
      this.incidentID = null;
      this._monthlyID = null;
      this.activeContent = null;
      this.activeContentClone = null;
    }
  }

  addOnFeature(addOnFeatures: GearTypes.BasicMasterEntityAddOnFeatures[]) {
    this.addOnIncidents = addOnFeatures.find(add => add.AddOnFeatureID == this.addOnFeatureIDs.IncidentManagement);
  }

  getFilterData(refreshOnChange?){
    if(!this._appService.getFacilityID()) {
      this.timer = setTimeout(() => this.getFilterData(), 1000);
      return;
    }

    // this._gearProxyService.RealTimeDataService.GetMapDefinition(
    //   this._appService.getAccessToken(),
    //   this.mapType.ITSIncidents,
    //   this._appService.getFacilityID(),
    //   this.formParameterApplied,
    //   (res: CoreTypes.MapDefinition) => {

    //     this.formParameterList = [];
    //     res.GeneralParameters.forEach(item => {
    //       item.RefreshOnChange = true;
    //       this.formParameterList.push(item);
    //     });

    //     this.formParameterApplied = JSON.parse(JSON.stringify(this.formParameterList));
    //     this.cloneParams = JSON.parse(JSON.stringify(this.formParameterList));
    //     setTimeout(() => {
    //       this.enableFilter = true;
    //       if(refreshOnChange) this.loaderFilter = 0;
    //     }, 100);
    //     if(!refreshOnChange) {
    //       this.getRecursively();
    //     }
    //   },
    //   err => {
    //     this.enableFilter = true;
    //     this.loaderFilter = 2;
    //     this.status = 2;
    //     this.formParameterApplied = JSON.parse(JSON.stringify(this.cloneParams));
    //     this._errorBackEnd = err.Message;
    //     this._appService.showException(err);
    //   }
    // )
    if(!refreshOnChange) {
      this.getRecursively();
    }
  }

  async applyIncidentFilters(type?: string, refreshOnChange?: boolean) {
    this.loaderFilter = 1;
    this.subscription?.unsubscribe();
    this._errorBackEnd = "";
    if(!refreshOnChange) {
      this.clustersFullList = [];
      this.clustersFilteredList = [];
      this.indexTable = [];
      this.status = 0;
    }
    this._sequenceNumber = 0;
    let values = this.formParam.getFormParameterValues();
    values.forEach((item, i) => {
      if(!this.formParameterApplied[i])
        this.formParameterApplied.push(new CoreTypes.FormParameter);

      this.formParameterApplied[i].ParameterID = item.ParameterID;
      this.formParameterApplied[i].ParameterType = item.ParameterType;
      this.formParameterApplied[i].ValueDateEnd = item.ValueDateEnd;
      this.formParameterApplied[i].ValueDateStart = item.ValueDateStart;
      this.formParameterApplied[i].ValueDateStartExpression = item.ValueDateStartExpression;
      this.formParameterApplied[i].ValueDateEndExpression = item.ValueDateEndExpression;
      this.formParameterApplied[i].ValueMultiString = item.ValueMultiString;
      this.formParameterApplied[i].ValueNumber = item.ValueNumber;
      this.formParameterApplied[i].ValueString = item.ValueString;
      this.formParameterApplied[i].RefreshOnChange = true;
    });
    if (this.formParameterApplied.findIndex(p => p.RefreshOnChange === true) > -1) {
      this.getFilterData(refreshOnChange);
    }

    if(!refreshOnChange && !type) {
      this.clustersFullList = [];
      this.clustersFilteredList = [];
      this.indexTable = [];
      this._sequenceNumber = 0;
      this.getRecursively();
    }
  }

  emitChangeParam(param?) {
    this.paramSelected = new CoreTypes.FormParameter();
    this.paramSelected = param;
  }

  ChangeRefreshParameters(state: boolean) {
    this.formParameterList.forEach((param, i) => {
      if (param.ValueMultiString !== null && state === true &&  param.RefreshOnChange === true) {
        this._appService.onMultiSelectButtonState.next(state);
        this.emitChangeParam();
      }
      if (param.ValueMultiString !== null && state === false && param.RefreshOnChange === true) {
        this._appService.onMultiSelectButtonState.next(state);
        if (JSON.stringify(this.paramSelected) === JSON.stringify(param) && this.formParameterList.findIndex(p => param.ParameterType === 0 || param.ParameterType === 1) < 0) {
          this.sharedCommonService.onRefreshFormParameter.next(true);
        }
      }
    });
  }

  onInputFilter(e?) {
    if (e) {
      const target = (e.originalTarget)
        ? e.originalTarget.parentNode.offsetParent.className
        : (e.target) ? e.target.parentNode.offsetParent.className : null;
      if (target && target === "dropdown-menu ng-star-inserted") { return; }
    }
    window.clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => this.applyIncidentFilters('onFilter', true), 50);
  }

  onScrollEvent(e, scrollY?) {
    let element =  Array.from(document.querySelectorAll<HTMLElement>('.pac-container'));
    setTimeout(() => {
      if(document.getElementsByClassName('pac-container')[0] && this._incidentForm?.searchElementRef?.nativeElement){
        element.forEach(x => {
          let scrollTop = (Math.trunc(this._incidentForm?.searchElementRef?.nativeElement.getBoundingClientRect().top) + 39);
          if(scrollY) scrollTop = scrollTop + scrollY;
          x.style.cssText += ';top:'+ scrollTop + 'px !important';
          x.style.cssText += ';z-index:0 !important';
        });
      }
    }, 10);
  }

  @HostListener('window:scroll', ['$event'])
  scroll(event: KeyboardEvent) {
    this.onScrollEvent(event, window.scrollY);
  }
}

